var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationIcon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-128.6%",
    y: "-128.6%",
    width: "357.1%",
    height: "357.1%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-128.6%",
    y: "-128.6%",
    width: "357.1%",
    height: "357.1%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-128.6%",
    y: "-128.6%",
    width: "357.1%",
    height: "357.1%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-128.6%",
    y: "-128.6%",
    width: "357.1%",
    height: "357.1%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-128.6%",
    y: "-128.6%",
    width: "357.1%",
    height: "357.1%",
    filterUnits: "objectBoundingBox",
    id: "e"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.667 28a4.668 4.668 0 0 0 4.666-4.667v-4.666H4.667A4.668 4.668 0 0 0 0 23.333 4.668 4.668 0 0 0 4.667 28Z",
    fill: "#0ACF83",
    filter: "url(#a)",
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14a4.668 4.668 0 0 1 4.667-4.667h4.666v9.334H4.667A4.668 4.668 0 0 1 0 14Z",
    fill: "#A259FF",
    filter: "url(#b)",
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.667A4.668 4.668 0 0 1 4.667 0h4.666v9.333H4.667A4.668 4.668 0 0 1 0 4.667Z",
    fill: "#F24E1E",
    filter: "url(#c)",
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.333 0H14a4.668 4.668 0 0 1 4.667 4.667A4.668 4.668 0 0 1 14 9.333H9.333V0Z",
    fill: "#FF7262",
    filter: "url(#d)",
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 14A4.668 4.668 0 0 1 14 18.667 4.668 4.668 0 0 1 9.333 14 4.668 4.668 0 0 1 14 9.333 4.668 4.668 0 0 1 18.667 14Z",
    fill: "#1ABCFE",
    filter: "url(#e)",
    transform: "translate(9 9)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.667 37a4.668 4.668 0 0 0 4.666-4.667v-4.666h-4.666A4.668 4.668 0 0 0 9 32.333 4.668 4.668 0 0 0 13.667 37Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 23a4.668 4.668 0 0 1 4.667-4.667h4.666v9.334h-4.666A4.668 4.668 0 0 1 9 23Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.667A4.668 4.668 0 0 1 13.667 9h4.666v9.333h-4.666A4.668 4.668 0 0 1 9 13.667Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.333 9H23a4.668 4.668 0 0 1 4.667 4.667A4.668 4.668 0 0 1 23 18.333h-4.667V9Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.667 23A4.668 4.668 0 0 1 23 27.667 4.668 4.668 0 0 1 18.333 23 4.668 4.668 0 0 1 23 18.333 4.668 4.668 0 0 1 27.667 23Z",
    fill: "#1ABCFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon01);
export default __webpack_public_path__ + "static/media/integration-icon-01.3f4f541b1ceb55ed1f4333ba884f4d6e.svg";
export { ForwardRef as ReactComponent };